import styled from 'styled-components';

export const Container = styled.div`
  .monitoredBy {
    display: flex;
    align-items: center;
    gap: 0.25rem;
    background-color: ${(props) => props.theme.$gray400};
    color: ${(props) => props.theme.$gray700};
    font-size: 16px;
    padding: 1px;
    border-radius: 4px;
  }

  .monitoredBy i {
    font-size: 15px;
    line-height: 1;
  }

  .monitoredBy span {
    font-size: 12px;
    line-height: 1;
  }

  .first-balloon {
    right: 1.25rem;
    bottom: 0;
  }

  .databalloon[aria-label] {
    overflow: visible;
    z-index: 2;
  }
`;
